<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="8"
    height="12"
    class="icon-arrow-min"
    :class="{'icon-arrow-min_down': down, 'icon-arrow-min_left': left}"
  >
    <g>
      <use class="svg-colorized-el" xlink:href="#icon-arrow-min_fill"/>
      <use class="svg-colorized-el" xlink:href="#icon-arrow-min_stroke"/>
    </g>
    <defs>
      <path id="icon-arrow-min_fill" d="M5.784 5.495l-4.526 4.3a.764.764 0 0 1-1.042 0 .676.676 0 0 1 0-.99L4.22 5 .216 1.195a.676.676 0 0 1 0-.99.765.765 0 0 1 1.042 0l4.526 4.3A.68.68 0 0 1 6 5a.68.68 0 0 1-.216.495z"/>
      <path id="icon-arrow-min_stroke" d="M5.784 5.495l.345.363-.345-.363zm-4.526 4.3l-.344-.363.344.363zm-1.042 0l.344-.363-.344.363zm0-.99l.344.362-.344-.362zM4.22 5l.344.362L4.946 5l-.381-.363L4.22 5zM.216 1.195l-.345.363.345-.363zm0-.99L.56.568.216.205zm1.042 0L.914.568l.344-.363zm4.526 4.3l.345-.362-.345.362zm-.344.628l-4.526 4.3.689.724 4.526-4.3-.69-.724zm-4.526 4.3a.265.265 0 0 1-.354 0l-.689.724c.481.457 1.25.457 1.732 0l-.69-.725zm-.354 0a.176.176 0 0 1 0-.266l-.689-.725a1.176 1.176 0 0 0 0 1.715l.69-.725zm0-.266l4.005-3.805-.689-.725-4.005 3.805.69.725zm4.005-4.53L.56.833l-.688.725 4.004 3.804.689-.725zM.56.833a.176.176 0 0 1 0-.265l-.688-.725a1.176 1.176 0 0 0 0 1.715L.56.833zm0-.265a.265.265 0 0 1 .354 0l.689-.725a1.265 1.265 0 0 0-1.732 0l.69.725zm.354 0l4.526 4.3.689-.726-4.526-4.3-.689.726zm4.526 4.3A.18.18 0 0 1 5.5 5h1a1.18 1.18 0 0 0-.371-.857l-.69.724zM5.5 5a.181.181 0 0 1-.06.133l.689.725A1.18 1.18 0 0 0 6.5 5h-1z"/>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    red: Boolean,
    black: Boolean,
    down: Boolean,
    left: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.icon-arrow-min {
  &_down {
    g {
      transform: rotate(90 5 6);
    }
  }
  &_left {
      transform: rotate(180deg);
  }
}


</style>



// WEBPACK FOOTER //
// src/components/icons/IconArrowMin.vue